import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { RenderedService } from '../../rendered.service';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';
import { ViewsService } from '@services/views.service';
import { ViewUpdateService } from '@scaffold/services/view-update.service';
import { AddDataComponent } from '@scaffold/dialogs/add-data/add-data.component';
import { CourseService } from '@scaffold/services/course.service';
import { ItemsService } from '@scaffold/services/items.service';
import {
  ScaffoldDialogService,
  ScaffoldDialogRef,
} from '@app/framework/dialog/scaffold-dialog.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
    selector: 'scaffold-create',
    templateUrl: './create.component.html',
    styleUrls: ['../../rendered.component.scss', './create.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
/**
 * adds a button to open the create dialogue for a specified data type
 */
export class CreateComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  public destroy$: Subject<boolean> = new Subject<boolean>();

  dialogRef: ScaffoldDialogRef;
  created;
  /**
   *
   * @param cdr
   * @param renderedService
   * @param viewUpdate
   * @param viewService
   * @param courseService
   * @param itemsService
   * @param dialog
   */

  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    private viewUpdate: ViewUpdateService,
    public viewService: ViewsService,
    private courseService: CourseService,
    private itemsService: ItemsService,
    private dialog: ScaffoldDialogService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe(trigger => {
        this.cdr.detectChanges();
      });
  }
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
  /**
   * function create, add, duplicate the type of create btn
   * @param type
   * @param parent
   * @param add
   * @param duplicate
   */

  createData(type, parent, add, duplicate) {
    console.log(this.item);
    if (this.item?.use_defaults) {
      if (!this.created) {
        this.created = true;
        const default_data = {
          type: type,
          data: {},
        };
        this.item.new_defaults.forEach(def => {
          default_data.data[def.key] = def.value;
        });
        let path = '';
        if (this.info.type && this.info.id)
          path = this.info.type + '/' + this.info.id + '/';
        if (this.item.create_as_link && this.courseService.id) {
          path = 'courses/' + this.courseService.id + '/';
        }
        path += type;
        let placeholder = {
          type: type,
          data: {
            content: [
              {
                type: 'text',
                value: default_data.data['title'] || type,
              },
            ],
          },
        };
        this.viewUpdate.triggerListChange({
          list_type: 'list',
          placeholder: placeholder,
          type: type,
          parent_type: this.info.type,
          parent_id: this.info.id,
        });

        this.itemsService.createData(path, default_data).subscribe(d => {
          this.created = false;
          console.log(d);
          if (this.info) {
            console.log('update new item');
            this.viewUpdate.triggerListChange({
              list_type: 'list',
              type: type,
              added: d,
              parent_type: this.info.type,
              parent_id: this.info.id,
            });
            if (this.item.create_as_link && this.courseService.id) {
              let newurl = '/' + this.info.type + '/' + this.info.id;
              let data = {
                new_link: d.id,
                new_mode: 'list',
                new_type: d.type,
                set_position: this.item.set_position,
              };
              this.itemsService
                .saveViewData(newurl, { data: data })
                .subscribe(link => {
                  this.viewUpdate.triggerListChange({
                    list_type: 'link',
                    parent_id: this.info.id,
                    type: d.type,
                    added: { id: d.id, type: d.type, link_id: d.link_id },
                  });
                  var added = {
                    id: this.info.id,
                    type: this.info.type,
                    link_id: d.link_id,
                  };
                  this.viewUpdate.triggerListChange({
                    list_type: 'link',
                    parent_id: d.id,
                    type: d.type,
                    added: added,
                  });
                });
            }
          }
        });
      }
    } else {
      console.log(parent);
      const data = {};
      if (this.item?.param && this.item?.req_value) {
        data[this.item.param] = this.item.req_value;
      }
      if (this.item?.create_as_link && this.courseService.id) {
        parent = { type: 'courses', id: this.courseService.id };
      }
      let settings: any = {
        context: {
          data: {
            size: this.item?.modal_width_size,
            comp: this,
            parent: parent,
            link_position: this.item?.set_position,
            type: type,
            allowAdd: add,
            duplicate: duplicate,
            data: data,
            label: this.item?.heading,
            ...this.item,
          },
        },
      };
      this.dialogRef = this.dialog.open(AddDataComponent, settings);
      this.dialogRef.onClose.subscribe(result => {
        //console.log(result)
        if (result && (result !== 'string' || result.length > 0)) {
          if (this.item.param) {
            this.info[this.item.param] = result.id;
            this.item.value = result.id;
            this.itemsService.updateValue(
              this.item?.param,
              result.id,
              this.info,
              null
            );
          }
          if (this.item.create_as_link && this.courseService.id) {
            let newurl = '/' + this.info.type + '/' + this.info.id;
            let data = {
              new_link: result.id,
              new_mode: 'list',
              new_type: result.type,
              set_position: this.item.set_position,
            };
            this.itemsService
              .saveViewData(newurl, { data: data })
              .subscribe(link => {
                this.viewUpdate.triggerListChange({
                  list_type: 'link',
                  parent_id: this.info.id,
                  type: result.type,
                  added: {
                    id: result.id,
                    type: result.type,
                    link_id: result.link_id,
                  },
                });
                const added = {
                  id: this.info.id,
                  type: this.info.type,
                  link_id: result.link_id,
                };
                this.viewUpdate.triggerListChange({
                  list_type: 'link',
                  parent_id: result.id,
                  type: result.type,
                  added: added,
                });
              });
          }
        }
      });
    }
  }
}
